import { SvgExternalLink } from '@loomhq/lens';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as analytics from 'utilities/analytics';

import InstallDesktopRebrandImg from 'img/workspace-onboarding/install-desktop-app-rebrand.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { markEligibleElementAsCompleteForSelectedWorkspace } from '../../../utilities';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { useGetSelectedWorkspace } from '../../../../../../hooks/workspace';
import { selectUserHasUsedDesktop } from '../../../../../../selectors/user';
import { INSTALL_DESKTOP_APP_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

import DownloadDesktopButton from 'components/download-desktop-button';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360002179357-Install-the-Loom-Desktop-App-';

const InstallDesktopAppCard = () => {
  const dispatch = useDispatch();
  const userHasUsedDesktop = useSelector(selectUserHasUsedDesktop);

  const currentWorkspace = useGetSelectedWorkspace();

  // if we notice user has used desktop app. Mark it as complete
  useEffect(() => {
    if (!userHasUsedDesktop || Object.keys(currentWorkspace).length === 0) {
      return;
    }

    markEligibleElementAsCompleteForSelectedWorkspace(
      dispatch,
      [currentWorkspace],
      INSTALL_DESKTOP_APP_CARD_KEY
    );
  }, [currentWorkspace, dispatch, userHasUsedDesktop]);

  const header = 'Install the Desktop App';
  const description = 'Get drawing tools, HD recording on Mac, and more.';

  const primaryAction = (
    <DownloadDesktopButton
      buttonText="Install app"
      afterOnClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: INSTALL_DESKTOP_APP_CARD_KEY,
        });
      }}
    />
  );

  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'secondary',
          card: INSTALL_DESKTOP_APP_CARD_KEY,
        });

        window.open(SUPPORT_ARTICLE_LINK);
      }}
    >
      Learn more
    </DashboardOnboardingSecondaryAction>
  );

  return (
    <DashboardOnboardingCard
      cardKey={INSTALL_DESKTOP_APP_CARD_KEY}
      heading={header}
      description={description}
      centerpiece={<img src={InstallDesktopRebrandImg} />}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="You have installed the Loom Desktop App."
    />
  );
};

export default InstallDesktopAppCard;
